import { render, staticRenderFns } from "./CompanyWizardStep.vue?vue&type=template&id=58f705b6&scoped=true&"
import script from "./CompanyWizardStep.vue?vue&type=script&lang=js&"
export * from "./CompanyWizardStep.vue?vue&type=script&lang=js&"
import style0 from "./CompanyWizardStep.vue?vue&type=style&index=0&id=58f705b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f705b6",
  null
  
)

export default component.exports